import types from '../../types/types';

const initialState = {};

const preRegistrationReducer = ( state = initialState, action: any ) => {

    switch ( action.type ) {
        
        case types.preRegistrationFormSaveData:
            return {
                ...state,
                ...action.payload
            }

        case types.deletePreRegistrationData:
            return {}

        default:
            return state;

    }

}

export default preRegistrationReducer;

